exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.guestflip-review[data-v-58f4ec50] {\n  border: 1px solid #ccc;\n  border-radius: 5px;\n  padding: 1rem;\n  margin: 1rem 0;\n}\n.review-contextual-menu .dots img[data-v-58f4ec50] {\n  width: 20px;\n}\n.comment-section[data-v-58f4ec50] {\n  margin-top: 1rem;\n}\n.comment-container[data-v-58f4ec50] {\n  margin-bottom: 1rem;\n}\n.manager-response[data-v-58f4ec50] {\n  padding: 1rem;\n  border: 1px solid #eee;\n  background-color: #f9f9f9;\n}\n", ""]);

// exports
